import React, { useCallback, useContext } from "react";
import styled, { css } from "styled-components";
import { MessageFieldName, MessageFieldValue } from "views/components/messagelist/MessageField";
import CommonFavoriteIcon from "views/components/common/CommonFavoriteIcon";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
const DefinitionDescription = styled.dd(
  ({ theme }) => `
  font-family: ${theme.fonts.family.monospace};
`
);
const FieldValueContainer = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
  `
);
const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
    align-items: center;
  `
);
const MessageFieldEditModeListItem = ({ fieldName, fieldType, value, isFavorite, onFavoriteToggle }) => {
  const favTitle = isFavorite ? `Remove ${fieldName} from favorites` : `Add ${fieldName} to favorites`;
  const { message } = useContext(MessageFavoriteFieldsContext);
  const _onFavoriteToggle = useCallback(() => onFavoriteToggle(fieldName), [fieldName, onFavoriteToggle]);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(CommonFavoriteIcon, { isFavorite, title: favTitle, onClick: _onFavoriteToggle }), /* @__PURE__ */ React.createElement(FieldValueContainer, null, /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement(MessageFieldName, { message, fieldName, fieldType })), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(DefinitionDescription, { "data-testid": `message-field-value-${fieldName}` }, /* @__PURE__ */ React.createElement(MessageFieldValue, { value, fieldName, fieldType, message })))));
};
export default MessageFieldEditModeListItem;
